
// Use this when you want to make it clear that the types are a mismatch, but it can't easily be fixed everywhere all at once.
// This way, you can at least see runtime errors that point you to places that need to be fixed.
// And then ideally when all places are fixed, a call to this function may be deleted.
// The most useful scenario for this right now is for input or output bindings in a view,
// because the types are not currently checked as strictly as they could be.
// (This would be less necessary or maybe not necessary at all with the angular and typescript strict flags turned on. TFS #79215)
// This was changed to log an error instead of throw an error, so that it doesn't picked up as an unhandled error.
export function throwInvalidValue(propertyName: string, value: any): void {
  console.error(new Error(`'${propertyName}' is set to an invalid value based on its type,` +
    ` which is cheating the type system; value: ${value}`
  ));
}
